import { LoginPage as KitLoginPage } from 'auth-sso-kit/client';
import { useT } from '../i18n';

export function LoginPage() {
  const { t } = useT();
  return (
    <KitLoginPage
      title={t('login.title')}
      subtitle={t('login.subtitle')}
      oidcButtonLabel={t('login.oidcButton')}
      emailPlaceholder={t('login.emailPlaceholder')}
      labels={{
        emailLabel: t('login.emailLabel'),
        passwordLabel: t('login.passwordLabel'),
        passwordPlaceholder: t('login.passwordPlaceholder'),
        submitLabel: t('login.submit'),
        submittingLabel: t('login.submitting'),
        footerOpen: t('login.footer.open'),
        footerAllowlist: t('login.footer.allowlist'),
        errEmailRequired: t('login.err.emailRequired'),
        errPasswordRequired: t('login.err.passwordRequired'),
        errLoginFailed: t('login.err.loginFailed'),
        errNotAuthorized: t('login.err.notAuthorized'),
        errOidcFailed: t('login.err.oidcFailed'),
        errNoEmail: t('login.err.noEmail'),
      }}
    />
  );
}
